//@flow
import React from 'react';
import { HiverAxios, toggleModal } from 'h-commons';
import { PAYMENT_INIT, PAYMENT_DONE, PAYMENT_FAILED ,RESET_PAYMENT_ERROR} from './types';
import PaymentSuccessModal from '../components/Account/PaymentSuccessModal';
import { setSessionIdToUrl } from 'h-commons';

export const makePayment = (invoiceNumber: Number, userSession: string | null, isChargeBeeEnabled: Boolean ) => (dispatch: Function) => {
    dispatch({
        type: PAYMENT_INIT
    });
  
    dispatch({
        type : RESET_PAYMENT_ERROR
    });
    let url = (isChargeBeeEnabled) ? `/api/payment/invoice/${invoiceNumber}` : `/stripe/trigger_payment/${invoiceNumber}`;
    HiverAxios({
        url,
        type: isChargeBeeEnabled ? 'GET' : 'POST',
        callback: (response) => {
            dispatch({ 
                type: PAYMENT_DONE 
            });
            
            dispatch(toggleModal(<PaymentSuccessModal 
                pendingCount = {response.data.pending_count}
                onClose={() => {
                    dispatch(toggleModal());
                    let refreshLink = "";
                    if(response && response.data.pending_count > 0)
                        refreshLink = `/app/settings/account/pending-invoices`;
                    else
                        refreshLink = `/app/settings/account/invoice/${invoiceNumber}`;

                    if (userSession)
                        refreshLink = setSessionIdToUrl(refreshLink, userSession);
                    window.location.replace(refreshLink);

                }}
            />));
        },
        onfail: (e) => {
           
            var msg = ("response" in e  &&  e.response.data) ? e.response.data.body.error.message : "Card was declined";
            dispatch({
                type: PAYMENT_FAILED,
                payload: msg
            });
        }
    });
}
